import notificationReducer from '@features/components/Notification/notificationSlice.ts';
import globalConfirmPromptReducer from '@features/components/Prompt/globalConfirmPromptSlice.ts';
import tagDetailReducer from '@features/TagList/tagDetailSlice.ts';
import tagPrintReducer from '@features/TagPrint/tagPrintSlice.ts';
import lostItemDetailReducer from '@pages/LostItems/lostItemDetailSlice.ts';
import {
  type Action,
  configureStore,
  createListenerMiddleware,
  isAnyOf,
  type ThunkAction,
} from '@reduxjs/toolkit';

import { entrySplitApi } from './entryApi.ts';
import appReducer from './reducers/appSlice.ts';
import authReducer, { login, logout } from './reducers/authSlice.ts';

const authApiCacheMiddleware = createListenerMiddleware();
authApiCacheMiddleware.startListening({
  matcher: isAnyOf(login, logout),
  effect: (_action, listenerApi) => {
    listenerApi.dispatch(entrySplitApi.util.resetApiState());
  },
});

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [entrySplitApi.reducerPath]: entrySplitApi.reducer,
    auth: authReducer,
    app: appReducer,
    globalConfirmPrompt: globalConfirmPromptReducer,
    notification: notificationReducer,
    tagDetail: tagDetailReducer,
    lostItemDetail: lostItemDetailReducer,
    tagPrint: tagPrintReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(authApiCacheMiddleware.middleware, entrySplitApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
